import { render, staticRenderFns } from "./Complain_History.vue?vue&type=template&id=58229c76&scoped=true"
import script from "./Complain_History.vue?vue&type=script&lang=js"
export * from "./Complain_History.vue?vue&type=script&lang=js"
import style0 from "./Complain_History.vue?vue&type=style&index=0&id=58229c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58229c76",
  null
  
)

export default component.exports